import angular from 'angular';
import routesSchoolCommonRoom from './school-common-room.routes';

import {SelectSchoolCommonRoom} from './select/select.component';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.modules.schoolCommonRoom', [])
  .component('selectSchoolCommonRoomComponent', SelectSchoolCommonRoom)
  .config(routesSchoolCommonRoom)
  .name;
